import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";

// reactstrap components
import { Row, Col, Container } from "reactstrap";
import ProgressBar from "../../components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST } from "../../services/api_service.js";

// views 
import Documentos from "../../views/Shared/Documentos";
import Declaracao from "../../views/Shared/Declaracao";
import IdentificacaoTaxaFislurb from '../../views/Shared/IdentificacaoTaxaFislurb';

//Context
import { useAuth } from '../../context/auth';
import CardRejeicaoRequerimento from './components/CardRejeicaoRequerimento';

export default function RequerimentoTaxaFislurb({ history }) {
    const { session, setupSistema, setLoading } = useAuth();

    const location = useLocation();

    const [requerimento, setRequerimento] = useState(null);

    const steps = ["Identificação Taxa FisLurb", "Documentos"];

    const [step, set_step] = useState(0);

    const [opcao, set_opcao] = useState({});

    const handleProximoStep = (_requerimento) => {
        if (step === 3) {
            history.push("opcoes");
        } else {
            setRequerimento(_requerimento);
            set_step((prevState) => prevState + 1);
        }
    };

    const handleStepAnterior = (_requerimento) => {
        setRequerimento(_requerimento);
        if (set_step < 0) set_step(0);
        else set_step((prevState) => prevState - 1);
    };

    const loadRequerimento = async () => {
        setLoading(true);
        try {
            if (location.state.requerimento == null) {
                const json_submit = {
                    protocolo_Id: location.state.protocolo.protocolo_Id,
                    requerimento_Id: 0,
                    nomeSolicitante: location.state.protocolo.nomeSolicitante,
                    email: location.state.protocolo.email,
                    cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                    setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
                };

                const { data } = await api_POST('requerimento/PostRequerimento', json_submit);

                set_opcao({
                    tipoCadastro: "Requerimento",
                    segmento: data.setupSolicitacaoAcao.setupSolicitacao.categoria?.segmento,
                    categoria: data.setupSolicitacaoAcao.setupSolicitacao.categoria
                });
                setRequerimento(data);
                set_step(0);
            } else {
                const { data } = await api_GET('requerimento/' + location.state.requerimento.requerimento_Id);

                set_opcao({
                    tipoCadastro: "Requerimento",
                    segmento: "Grande Gerador",
                    categoria: data.setupSolicitacaoAcao.setupSolicitacao.categoria
                });
                setRequerimento(data);
                if (data.status === "Divergente") {
                    set_step(0);
                } else if (data.etapaCadastro != null) {
                    set_step(data.etapaCadastro);
                }
            }
        } catch (err) {
            showMessage("Aviso", err.message, 'error', null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadRequerimento();
    }, []);

    return (
        <>
            {requerimento != null && step < 3 && (
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    <CardRejeicaoRequerimento requerimento={requerimento} setupSistema={setupSistema} />

                    {step === 0 && (
                        <IdentificacaoTaxaFislurb
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                        />
                    )}

                    {step === 1 && (
                        <Documentos
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}

                    {step === 2 && (
                        <Declaracao
                            item={requerimento}
                            handleFinalizarCadastro={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    )}
                </div>
            )}

            {requerimento != null && step === 3 && (
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row
                            style={{
                                borderBottom: "1px solid rgba(0, 0, 0, .5)",
                                paddingBottom: "10px",
                                paddingTop: "10px",
                            }}
                        >
                            <Col md="12">
                                <span
                                    className={`${session && session.tipoAcesso === "AreaRestrita"
                                        ? "text-white"
                                        : "text-black"
                                        }`}
                                >
                                    Este requerimento já foi finalizado. Para visualizar e
                                    acompanhar as informações do requerimento, acesse o menu "Meu
                                    Cadastro".
                                </span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            )}
        </>
    )
}
